import { useWorkspace } from "@/api/auth/queries";
import { useWorkspaceMembers } from "@/api/workspace/queries";
import { allowLimit } from "@/helpers/limits";
import { Limits } from "@/types/billing";
import { useMemo } from "react";

export const useLimits = (limitKey: keyof Limits) => {
  const workspace = useWorkspace();
  const { data: members } = useWorkspaceMembers();

  const value = useMemo(() => {
    switch (limitKey) {
      case "resolutions_per_month":
        return workspace?.monthly_totals.resolutions || false;
      case "seats":
        return members?.length || false;
      case "phone_calls_per_month":
        return workspace?.monthly_totals.phone_calls || false;
      default:
        return false;
    }
  }, [workspace, limitKey, members]);

  const limitValue = useMemo(() => {
    const value = workspace?.active_subscription.plan?.limits[limitKey];
    if (value === -1) return "∞";
    if (typeof value === "number") return value;
    return value ? "Included" : "Not Included";
  }, [workspace, limitKey]);

  const isLimitReached = useMemo(() => {
    if (!workspace) return false;
    console.log(workspace, limitKey, value);
    console.log(allowLimit(workspace, limitKey, value));
    return !allowLimit(workspace, limitKey, value);
  }, [workspace, limitKey, value]);

  const featureName = useMemo(() => {
    switch (limitKey) {
      case "resolutions_per_month":
        return "Resolutions";
      case "seats":
        return "Seats";
      case "phone_calls_per_month":
        return "Phone Calls";
      case "custom_branding":
        return "Widget Options";
      case "reasoning_ai":
        return "Reasoning AI";
      case "store_access":
        return "Store Access";
      case "premium_models":
        return "Premium Models";
      default:
        return "";
    }
  }, [limitKey]);

  const availableMinPlan = useMemo(() => {
    switch (limitKey) {
      case "resolutions_per_month":
        return "Starter";
      case "seats":
        return "Pro";
      case "phone_calls_per_month":
        return "Human-Level";
      case "custom_branding":
        return "Pro";
      case "reasoning_ai":
        return "Human-Level";
      case "store_access":
        return "Pro";
      case "premium_models":
        return "Human-Level";
      default:
        return "";
    }
  }, [workspace]);

  return { value, limitValue, isLimitReached, featureName, availableMinPlan };
};
